import { StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import type { ComponentProps } from "react";

import { useThemedStyles, type ThemeColors } from "~/styles/theme";

export function Screen({
  style,
  ...props
}: ComponentProps<typeof SafeAreaView>) {
  const stylesheet = useThemedStyles(makeStyles);
  return <SafeAreaView style={[stylesheet.screen, style]} {...props} />;
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    screen: { flex: 1, backgroundColor: colors.background },
  });
